import {
  FaWhatsapp,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaEnvelope,
} from "react-icons/fa"

export default function ContactInfo() {
  return (
    <div className="space-y-6">

      <div>
        <span className="text-blue-600 font-semibold uppercase tracking-wider">
          Contact
        </span>

        <h2 className="mt-3 text-3xl font-bold text-gray-900">
          Parlons de vos besoins
        </h2>

        <p className="mt-4 text-gray-600 leading-relaxed">
          Notre équipe est à votre disposition pour répondre à vos
          demandes concernant nos produits textiles, mercerie et
          accessoires.
        </p>
      </div>

      <div className="space-y-4">

        <a
          href="https://wa.me/21628718432"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-4 p-4 bg-white rounded-xl border border-gray-100 hover:shadow-md transition"
        >
          <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
            <FaWhatsapp className="text-green-600" />
          </div>

          <div>
            <p className="font-semibold text-gray-900">
              WhatsApp
            </p>

            <p className="text-gray-600">
              +216 28 718 432
            </p>
          </div>
        </a>

        <a
          href="tel:+21628718432"
          className="flex items-center gap-4 p-4 bg-white rounded-xl border border-gray-100 hover:shadow-md transition"
        >
          <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center">
            <FaPhoneAlt className="text-blue-600" />
          </div>

          <div>
            <p className="font-semibold text-gray-900">
              Téléphone
            </p>

            <p className="text-gray-600">
              +216 28 718 432
            </p>
          </div>
        </a>

        <a
          href="mailto:khenissi.khaled23@gmail.com"
          className="flex items-center gap-4 p-4 bg-white rounded-xl border border-gray-100 hover:shadow-md transition"
        >
          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
            <FaEnvelope className="text-red-600" />
          </div>

          <div>
            <p className="font-semibold text-gray-900">
              E-mail
            </p>

            <p className="text-gray-600">
              khenissi.khaled23@gmail.com
            </p>
          </div>
        </a>

        <div className="flex items-center gap-4 p-4 bg-white rounded-xl border border-gray-100">
          <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center">
            <FaMapMarkerAlt className="text-gray-700" />
          </div>

          <div>
            <p className="font-semibold text-gray-900">
              Adresse
            </p>

            <p className="text-gray-600">
              12 Rue des Tanneurs, Tunis, Tunisie
            </p>
          </div>
        </div>

      </div>

    </div>
  )
}